export enum TaxBenefitsReviewMode {
  Provider = 'provider',
  Independent = 'independent',
}
